module.exports = __webpack_public_path__ + "img/cyprus.2d0af0b4.svg";